import {
  Icon,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import React from "react";
import { HiOutlineCalendar } from "react-icons/hi";

interface CustomDateInputProps extends InputProps {
  height?: string | number | object;
  width?: string | number | object;
}

export const CustomDateInput = React.forwardRef<
  HTMLInputElement,
  CustomDateInputProps
>(({ height = "38px", width = "122px", ...props }, ref) => (
  <Input
    boxShadow="none"
    borderColor="#ccc"
    borderRadius="base"
    height={height}
    width={width}
    {...props}
    ref={ref}
  />
));

interface CustomDateTimeInputProps extends InputProps {
  height?: string | number | object;
  width?: string | number | object;
}

export const CustomDateTimeInput = React.forwardRef<
  HTMLInputElement,
  CustomDateTimeInputProps
>(({ height, width, ...props }, ref) => (
  <InputGroup width={width}>
    <Input height={height} {...props} ref={ref} />
    <InputRightElement pointerEvents="none">
      <Icon as={HiOutlineCalendar} color="gray.400" />
    </InputRightElement>
  </InputGroup>
));
